import { ataResolver, combineResolvers, heliumCommonResolver, resolveIndividual, } from "@helium/spl-utils";
import { getAccount } from "@solana/spl-token";
import { init } from ".";
import { voterWeightRecordKey } from "./pdas";
export * from "./constants";
export * from "./pdas";
export * from "./resolvers";
export const vsrResolvers = combineResolvers(heliumCommonResolver, ataResolver({
    instruction: "initializeRegistrarV0",
    account: "tokenAccount",
    mint: "collection",
    owner: "registrar",
}), ataResolver({
    instruction: "initializePositionV0",
    account: "vault",
    mint: "depositMint",
    owner: "position",
}), ataResolver({
    instruction: "depositV0",
    account: "vault",
    mint: "mint",
    owner: "position",
}), ataResolver({
    instruction: "withdrawV0",
    account: "vault",
    mint: "depositMint",
    owner: "position",
}), ataResolver({
    instruction: "withdrawV0",
    account: "destination",
    mint: "depositMint",
}), ataResolver({
    instruction: "depositV0",
    account: "depositToken",
    mint: "mint",
    owner: "depositAuthority",
}), ataResolver({
    instruction: "withdrawV0",
    account: "vault",
    mint: "depositMint",
    owner: "position",
}), ataResolver({
    instruction: "transferV0",
    account: "sourceVault",
    mint: "depositMint",
    owner: "sourcePosition",
}), ataResolver({
    instruction: "transferV0",
    account: "targetVault",
    mint: "depositMint",
    owner: "targetPosition",
}), ataResolver({
    account: "positionTokenAccount",
    mint: "mint",
    owner: "positionAuthority",
}), ataResolver({
    instruction: "initializePositionV0",
    account: "positionTokenAccount",
    mint: "mint",
    owner: "recipient",
}), ataResolver({
    instruction: "ledgerTransferPositionV0",
    account: "toTokenAccount",
    mint: "mint",
    owner: "to"
}), ataResolver({
    instruction: "ledgerTransferPositionV0",
    account: "fromTokenAccount",
    mint: "mint",
    owner: "from"
}), resolveIndividual(async ({ accounts, path, provider }) => {
    if (path[path.length - 1] === "recipient") {
        // @ts-ignore
        return provider.wallet.publicKey;
    }
    if (path[path.length - 1] === "solDestination") {
        // @ts-ignore
        return provider.wallet.publicKey;
    }
    else if (path[path.length - 1] === "voterWeightRecord" &&
        accounts.registrar &&
        (accounts.voterAuthority || accounts.positionTokenAccount)) {
        if (!accounts.voterAuthority) {
            return voterWeightRecordKey(accounts.registrar, accounts.voterAuthority)[0];
        }
        else {
            const acct = await getAccount(provider.connection, accounts.positionTokenAccount);
            return voterWeightRecordKey(accounts.registrar, acct.owner)[0];
        }
    }
    else if (path[path.length - 1] === "positionUpdateAuthority" &&
        accounts.registrar) {
        const vsr = await init(provider);
        const reg = await vsr.account.registrar.fetch(accounts.registrar);
        // @ts-ignore
        return reg.positionUpdateAuthority || provider.wallet.publicKey;
    }
}));
//# sourceMappingURL=resolvers.js.map